/**
 * ページスムーススクロール
 */

  import $ from 'jquery';
  import {
    $header
  } from './globals.js'

  // header の高さ
  const headerHeight = $header.outerHeight(true) || 0;

  /**
   * id の要素の座標まで移動する
   * @param {number} id  要素のid
   * @param {number} pad 余白
   */
  let scroll = (id, pad = 0) => {
    let top = $(id).offset().top;
    $('html, body').animate({
      'scrollTop': top - pad
    });
  }

  // アンカーリンククリック時
  $('a[href^="#"]').on('click', function(e){
    e.preventDefault();
    let id = $(this).attr('href');
    // 実行
    scroll(id, 30 + headerHeight);
  });

  // ページ読み込み時
  $(window).on('load', function(){
    // デフォルトアンカーをリセットするために 0 にセット
    window.scrollTo(0, 0);
    // 非同期を遅らせるため遅延させる
    setTimeout(()=>{
      let id = location.hash;
      if (id.length > 0) {
        // 実行
        scroll(id, 30);
      }
    }, 10);
  });
